<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="个人信息" name="info">
            <info/>
          </el-tab-pane>
          <el-tab-pane label="修改密码" name="pass">
            <pass/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import info from './info';
import pass from './pass';

export default {
  data() {
    return {
      activeTab: 'info'
    };
  },
  methods: {

  },
  components: {
    info, pass
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/userCenter/index.vue